import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-70d0e33d"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "tips"
};
const _hoisted_2 = {
  class: "box"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = ["href", "target"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page_header", {
      circle: $props.isCircle
    }]),
    style: _normalizeStyle($props.bodyStyle)
  }, [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "tips", {}, undefined, true)]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "left", {}, undefined, true)]), _createElementVNode("a", {
    href: $props.link,
    target: $props.openOut ? '_blank' : '_self',
    class: "right",
    style: _normalizeStyle($props.rightStyle)
  }, [_renderSlot(_ctx.$slots, "right", {}, undefined, true)], 12, _hoisted_4)])], 6);
}